import React, { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface IPublicOnlyRouteProps {
  isAuth: boolean;
  children: ReactElement;
  redirectPath?: string;
}

function PublicOnlyRoute({
  isAuth,
  children,
  redirectPath = "/main"
}: IPublicOnlyRouteProps): ReactElement {
  const location = useLocation();

  return isAuth ? (
    <Navigate to={redirectPath} state={{ from: location.pathname }} replace />
  ) : (
    children
  );
}

export default PublicOnlyRoute;
